import { values } from 'lodash'
import PropTypes from 'prop-types'

import { COMPONENT_INGREDIENT_TYPES } from '../../common/constants'
import { idPropType } from '../../common/prop-types'

const componentIngredientPropType = PropTypes.shape({
  id: idPropType.isRequired,
  type: PropTypes.oneOf(values(COMPONENT_INGREDIENT_TYPES)),
})

export default componentIngredientPropType
